__webpack_require__.p = "/course-visualization-app/";